import FormationConfig from './formationConfig'
import FormationRowConfig from './formationRowConfig'
import FormationColConfig from './formationColConfig'
import FormationColTypeEnum from './formationColTypeEnum'
import FormationColTextConfig from './formationColTextConfig'
import FormationColHtmlConfig from './formationColHtmlConfig'
import FormationColStyledConfig from './formationColStyledConfig'
import FormationColButtonConfig from './formationColButtonConfig'
import FormationColButtonsConfig from './formationColButtonsConfig'
import FormationColCheckboxConfig from './formationColCheckboxConfig'

export default {
  FormationConfig,
  FormationRowConfig,
  FormationColConfig,
  FormationColTypeEnum,
  FormationColStyledConfig,
  FormationColTextConfig,
  FormationColHtmlConfig,
  FormationColButtonConfig,
  FormationColButtonsConfig,
  FormationColCheckboxConfig
}



/** WEBPACK FOOTER **
 ** ./src/docs/types.js
 **/